module.exports = __webpack_public_path__ + "socicon.7dbbd6b23645dda36592.woff";


//////////////////
// WEBPACK FOOTER
// ./~/socicon/font/socicon.woff
// module id = 279
// module chunks = 13